<template>
  <section id="testimonials" class="py-24 bg-white">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center mb-16">
        <h2 class="text-3xl font-bold text-slate-900 mb-4">Opinie użytkowników</h2>
        <p class="text-lg text-slate-600 max-w-2xl mx-auto">Prawdziwe historie sukcesu naszych użytkowników</p>
      </div>

      <div class="grid lg:grid-cols-3 gap-8">
        <article class="bg-slate-50 border border-slate-200 rounded-3xl p-10">
          <div class="text-amber-500 text-2xl mb-6 tracking-wide">★★★★★</div>
          <p class="text-slate-600 leading-relaxed mb-8">
            "Dzięki CV-Tailor dostałem pracę!<br>
            Na rozmowie czułem się pewnie,
            bo wiedziałem, że CV nie kłamie –
            wszystko co tam było, mogłem
            obronić."
          </p>
          <div class="flex items-center gap-4">
            <div class="w-14 h-14 rounded-full bg-violet-100 text-violet-600 font-bold text-xl flex items-center justify-center">MK</div>
            <div>
              <p class="text-lg font-bold text-slate-900">Michał Kowalski</p>
              <p class="text-slate-500">Project Manager</p>
            </div>
          </div>
        </article>

        <article class="bg-slate-50 border border-slate-200 rounded-3xl p-10">
          <div class="text-amber-500 text-2xl mb-6 tracking-wide">★★★★★</div>
          <p class="text-slate-600 leading-relaxed mb-8">
            "Przeszłam przez ATS, które
            wcześniej mnie odrzucało. CV-Tailor
            wydobył umiejętności, o których
            zapomniałam, i dopasował je do
            wymagań oferty."
          </p>
          <div class="flex items-center gap-4">
            <div class="w-14 h-14 rounded-full bg-violet-100 text-violet-600 font-bold text-xl flex items-center justify-center">AN</div>
            <div>
              <p class="text-lg font-bold text-slate-900">Anna Nowak</p>
              <p class="text-slate-500">UX Designer</p>
            </div>
          </div>
        </article>

        <article class="bg-slate-50 border border-slate-200 rounded-3xl p-10">
          <div class="text-amber-500 text-2xl mb-6 tracking-wide">★★★★★</div>
          <p class="text-slate-600 leading-relaxed mb-8">
            "Zero stresu przed rozmową.
            Wiedziałem, że każdy punkt w CV
            to prawda, którą potrafię rozwinąć.
            To daje niesamowitą pewność
            siebie."
          </p>
          <div class="flex items-center gap-4">
            <div class="w-14 h-14 rounded-full bg-emerald-100 text-emerald-600 font-bold text-xl flex items-center justify-center">PW</div>
            <div>
              <p class="text-lg font-bold text-slate-900">Piotr Wiśniewski</p>
              <p class="text-slate-500">Software Engineer</p>
            </div>
          </div>
        </article>
      </div>
    </div>
  </section>
</template>
